ks-page-product > ks-page-base > .listing-heading {
    text-align: center;
    margin-top: 15px;
    font-size: large;
    font-weight: 700;
    margin-bottom: 15px;
    font-family: var(--font-emphasis);
}

ks-page-product > ks-page-base > ks-product-container {
    margin-bottom: 15px;
}